import React, { Suspense } from 'react';

const LazyDatasourceRenderFailedAnalyticsWrapper = React.lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_linkdatasource-datasourceRenderFailedAnalyticsWrapper" */ './datasourceRenderFailedAnalyticsWrapper'
		),
);

export const LazyLoadedDatasourceRenderFailedAnalyticsWrapper = (props: any): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyDatasourceRenderFailedAnalyticsWrapper {...props} />
	</Suspense>
);
